















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { VIPCertificate, IVIPCertificatePdf, VIPCertificateRest, busy, auth } from "@/loader";

@Component
export default class CertificatePdfModal extends Vue {
	@Prop({ type: String, default: "pdf_modal" })
	public id!: string;

	@Prop({ type: VIPCertificate, default: null })
	public item!: VIPCertificate | null;

	public pdf: IVIPCertificatePdf | null = null;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get signed(): boolean {
		return this.item?.isSigned || false;
	}

	public get title(): string {
		return [this.item?.getTypeLabel(), this.item?.project?.name].filter(x => !!x).join(" : ");
	}

	public get content(): string {
		return this.item && this.pdf ? "data:application/pdf;base64," + this.pdf.content : "";
	}

	public get href() {
		return this.item?.documentUrl(auth.token) || "";
	}

	// public load() {
	// 	if (!this.item) {
	// 		return;
	// 	}

	// 	if (this.useHref) {
	// 		return;
	// 	}

	// 	if (this.item.pdf && this.item.pdf.signed === this.signed) {
	// 		this.pdf = this.item.pdf;
	// 		// this.$nextTick().then(() => this.$refs.link.click());
	// 	} else {
	// 		busy.set({ status: true, text: "Chargement du document ..." })
	// 		VIPCertificateRest.getPDF(this.item, this.signed).then(result => {
	// 			this.pdf = result.item || null;
	// 			// this.$nextTick().then(() => this.$refs.link.click());
	// 		}).finally(() => {
	// 			busy.set({ status: false });
	// 		});
	// 	}
	// }
}
